export default {
  content: 'Contenido',
  resource: 'Recurso',
  teacher: 'Docente: {teacher}',
  classNumber: 'Clase {classNumber}',
  className: 'Clase {classNumber}: {name}'
}

export const en = {
  content: 'Content',
  resource: 'Resource',
  teacher: 'Teacher: {teacher}',
  classNumber: 'Class {classNumber}',
  className: 'Class {classNumber}: {name}'
}

export const ca = {
  content: 'Contingut',
  resource: 'Recurs',
  teacher: 'Docent: {teacher}',
  classNumber: 'Classe {classNumber}',
  className: 'Classe {classNumber}: {name}'
}
